// extracted by mini-css-extract-plugin
module.exports = {"input":"HtxTextBox_input__1WT88","editing":"HtxTextBox_editing__2Wu58","enter":"HtxTextBox_enter__1Vbyn","delete":"HtxTextBox_delete__J_jjZ"};